<template>
  <page>
    <header-component
      :content-props="{
        hasUserMenu: true,
        hasSearch: true,
        hasDiscoverMenu: true,
        hasLibraryLink: true,
        hasHighlightsLink: true
      }"
    />

    <cancellation-survey-header :is-leaving-mup="isLeavingMup" />

    <div class="cancellation-survey__container">
      <cancellation-survey-form
        class="cancellation-survey__form"
        :eligible-for-churn-prevention="eligibleForChurnPrevention"
        :is-leaving-mup="isLeavingMup"
        :survey-options="surveyOptions"
        :sku="sku"
      />
    </div>
  </page>
</template>

<script>
import Page from "@/shared/page"
import HeaderComponent from "@/features/header/components"
import CancellationSurveyHeader from "./cancellation-survey-header"
import CancellationSurveyForm from "./cancellation-survey-form"

export default {
  name: "CancellationSurveyPage",
  components: {
    CancellationSurveyForm,
    CancellationSurveyHeader,
    Page,
    HeaderComponent
  },
  props: {
    surveyOptions: {
      type: Array,
      default: () => []
    },
    eligibleForChurnPrevention: {
      type: Boolean,
      default: false
    },
    isLeavingMup: {
      type: Boolean,
      default: false
    },
    sku: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss">
.cancellation-survey {
  &__container {
    @include container;
    @include grid-css;
  }

  &__form {
    @include grid-css-element(12, 0);

    grid-column-start: 0;

    @include media(min-width, m) {
      @include grid-css-element(8, 2);

      grid-column-start: 3;
    }
  }
}
</style>
